import React, { memo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { brandRadarUrl } from "../../util/url";

import RadarIcon from "./assets/radar.svg";
import LogoIcon from "./assets/logo.svg";
import ArrowIcon from "./assets/arrow.svg";

import "./BrandRadarButton.css";

/**
 * 브랜드 레이더 진입 버튼
 * @param className 추가 클래스
 * @param brandName 진입할 대상 브랜드명 (없으면 기본 /brand-radar)
 * @returns {JSX.Element}
 * @constructor
 */
function BrandRadarButton({ className = "", brandName }) {
  return (
    <Link
      to={brandRadarUrl(brandName)}
      className={`BrandRadarButton ${className}`.trim()}
      aria-label="브랜드 레이더 열기"
    >
      <img
        className="BrandRadarButton-icon"
        src={RadarIcon}
        alt=""
        aria-hidden="true"
      />
      <img className="BrandRadarButton-logo" src={LogoIcon} alt="brand radar" />
      <span className="BrandRadarButton-badge">NEW</span>
      <img
        className="BrandRadarButton-arrow"
        src={ArrowIcon}
        alt=""
        aria-hidden="true"
      />
    </Link>
  );
}

BrandRadarButton.propTypes = {
  className: PropTypes.string,
  brandName: PropTypes.string,
};

export default memo(BrandRadarButton);
